import * as types from "../constants/logsConstants";
const initialState = {
  automationBuildLogs: [],
  automationBuildLog: null,
  total: 0,
};

const logsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.AUTOMATION_BUILD_LOGS:
      return {
        ...state,
        automationBuildLogs: action.payload,
        total: action.total,
      };
    case types.AUTOMATION_BUILD_LOG:
      return { ...state, automationBuildLog: action.payload };
    default:
      return state;
  }
};
export default logsReducer;
